<div class="error-container">
  <mode-simple-error capraIcon="illo-error-dataset" *ngIf="isUnknownError">
    <h4>Sorry, your query was successful, but we ran into problems displaying the data.</h4>
    <div>You can still access the dataset by downloading a csv <a [href]="csvLink" target="_self">export</a>.</div>
  </mode-simple-error>

  <div class="detailed-error" *ngIf="!isUnknownError">
    <p class="flamingo-error-header" *ngIf="errorType !== 'SizeLimit'">
      <capra-icon icon="icon-close" class="error-icon"></capra-icon>Sorry, we can't return your data for the following
      reasons:
    </p>
    <div class="error-header" *ngIf="errorType === 'SizeLimit'">
      Sorry, your query was successful, but we can't display or chart your data for the following reasons:
    </div>

    <div class="flamingo-error-message-container">
      <div class="error-message" *ngIf="errorType === 'SizeLimit'">
        Your query results (<span class="byte-size">{{ formattedByteSize }}</span
        >) are {{ formattedOverageSize }} over your Workspace's limit of {{ formattedByteLimit }}

        <a
          class="pull-right"
          [attr.href]="
            helpDocs.links[
              'https://mode.com/help/articles/querying-data/?utm_source=result_limit_cta#sorry,-this-data-is-larger-than-your-limit'
            ]
          "
          target="_blank"
        >
          <capra-button text="Learn more" variant="secondary" size="small"></capra-button>
        </a>
        <!-- Temporary solution until capra button supports links -->
      </div>

      <div class="error-message" *ngIf="errorType === 'TOO_MANY_COLUMNS'">
        Your query returns {{ errorResponse.result.stateProperties.columnCount }} columns, which exceeds our limit of
        {{ errorResponse.result.stateProperties.limit }}.
      </div>

      <div class="error-message" *ngIf="errorType === 'COLUMN_TOO_WIDE'">
        Your data contains one or more columns that exceed our column size limit of 1MB. Here's a summary of your
        columns and the approximate size of the data within them:
        <ul>
          <li *ngFor="let col of columns | orderBy: '-width' | slice: 0:5">
            <span class="column-name">{{ col.name }} </span
            ><span class="column-size">({{ readableBytes(col.width) }})</span>
          </li>
          <div *ngIf="columns.length > 5">and {{ columns.length - 5 }} more</div>
        </ul>
      </div>

      <div class="error-message" *ngIf="errorType === 'ROW_TOO_WIDE' && columns.length !== 0">
        Your data contains one or more rows that exceed our row size limit of 2MB. Here's a summary of your columns and
        the approximate size of the data within them:
        <ul>
          <li *ngFor="let col of columns | orderBy: '-width' | slice: 0:5">
            <span class="column-name">{{ col.name }} </span
            ><span class="column-size">({{ readableBytes(col.width) }})</span>
          </li>
          <div *ngIf="columns.length > 5">and {{ columns.length - 5 }} more</div>
        </ul>
      </div>

      <div
        class="error-message"
        *ngIf="errorType === 'ROW_TOO_WIDE' && columns.length === 0 && !!context && 'rowNumber'; in: context"
      >
        Row <span>{{ context.rowNumber }}</span> in your data exceeds our row size limit
        <span>{{ context.maximumRowWidth }} </span> bytes.
      </div>

      <div class="error-message" *ngIf="errorType === 'DATA_PROBLEM'">
        The following rows exceed our size limits:
        <ul>
          <li *ngFor="let problem of dataProblems | slice: 0:5">
            Row <span class="row-number">{{ problem.rowNumber }}</span> (occurring at column
            <span class="column-name">{{ problem.attributeName }}</span
            >)
          </li>
          <div *ngIf="dataProblems.length > 5">and {{ dataProblems.length - 5 }} more</div>
        </ul>
      </div>
    </div>

    <div class="footer-message">
      <p>Try editing your query, or access your data in another way:</p>
      <div class="actions">
        <a [href]="csvLink" target="_self">
          <!-- Temporary solution until capra button supports links -->
          <capra-button
            text="Export to CSV"
            icon="icon-export"
            variant="secondary"
            color="neutral"
            size="small"
          ></capra-button>
        </a>
        <capra-button
          (clicked)="goToNotebook()"
          text="Go to Notebook"
          variant="secondary"
          color="neutral"
          size="small"
        ></capra-button>
      </div>
    </div>
  </div>
</div>
